<template>
  <CardList
    ref="listRef"
    :title="tabItem.label"
    :options="pageOptions"
    :keyItem="tabItem"
    :dataType="{
      upload_type: UPLOAD_TYPE.BRAND,
      resource_type: tabItem.resource_type,
      model_type: tabItem.model_type,
    }"
  >
    <template #item="{ record, check, updateData }: any">
      <Card
        :data="transData(record, tabItem)"
        :keyItem="tabItem"
        :title="tabItem.label"
        :source="SOURCE.BRAND"
        :check="check"
        :menus="menuList"
        :menuFilter="menuFilter"
        :onUpdateData="updateData"
      />
    </template>
    <template #emptyContent>
      <EmptyContent />
    </template>
  </CardList>
</template>
<script lang="ts" setup>
import { transData, EmptyContent } from '../config'
import { getBrandList } from '~/api'
import { type PageOptions } from '~/hooks/usePage'
import { CardList, Card } from '~/features/pageList'

defineProps<{
  hasUpload: boolean
  menuFilter: (key: any, item: any) => boolean
}>()

const tabItem: any = useDictItem('brand', RESOURCE_TYPE.STUDIO)
const menuList: any[] = []
const listRef = ref()
const pageOptions = computed<PageOptions>(() => ({
  scroll: true,
  api: (params: any) =>
    getBrandList({
      ...params,
      resource_type: tabItem.resource_type,
      model_type: tabItem.model_type,
    }),
}))

const onTabChange = () => {
  listRef.value?.exitBatch()
  listRef.value?.toScrollTop()
}

const reload = () => {
  listRef.value?.reload()
}

defineExpose({ onTabChange, reload })
</script>

<style lang="scss" scoped>
:deep(.eye-icon) {
  right: 10px;
}
</style>
